import { lmsClient } from "api";

const buildGLMasterSequenceParams = (data = {}) => {
  const params = new URLSearchParams();
  params.append("pageIndex", data.pageIndex ?? 0);
  params.append("pageSize", data.pageSize ?? 10);
  params.append("journalTypeId", data.journalTypeId || "");
  params.append("branchId", data.branchId || "");
  params.append("batchId", data.batchId || "");
  return params.toString();
};

const GLMasterSequenceService = {};

GLMasterSequenceService.getGLMasterSequenceList = function (data = {}) {
  return lmsClient({
    url: `/lms/GLMasterSequence/search?${buildGLMasterSequenceParams(data)}`,
    method: "get",
  });
};

export default GLMasterSequenceService;
